import { render } from "./BusinessPlan.vue?vue&type=template&id=d801503c&scoped=true&ts=true"
import script from "./BusinessPlan.vue?vue&type=script&lang=ts"
export * from "./BusinessPlan.vue?vue&type=script&lang=ts"

import "./BusinessPlan.vue?vue&type=style&index=0&id=d801503c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d801503c"]])

export default __exports__